import { Get } from 'config/apiServiceConfig'

type GetFeatureServiceBulkUploadRequestType = {
  code: string
}

export type GetFeatureServiceBulkUploadResponseType = {
  data: {
    id: number
    bulkUploadServiceId: number
    name: string
    templateUrl: string
  }
  error: {
    status: boolean
    message: string
    code: number
  }
}

export type GetFeatureServiceBulkUploadInternalResponseType = {
  data: {
    id: number
    bulk_upload_service_id: number
    file_type: string
    name: string
    template_url: string
  }
  error: {
    status: boolean
    message: string
    code: number
  }
}

export const getFeatureServiceBulkUploadAPI = (params: GetFeatureServiceBulkUploadRequestType) =>
  Get<GetFeatureServiceBulkUploadResponseType>({
    url: '/api/bulk-upload/service-feature',
    params,
  })

export const getFeatureServiceBulkUploadInternalAPI = (
  params: GetFeatureServiceBulkUploadRequestType,
) =>
  Get<GetFeatureServiceBulkUploadInternalResponseType>({
    url: '/upload/internal/v1/bulk-upload/service-feature',
    params,
  })
